import { render, staticRenderFns } from "./ProductSelector.vue?vue&type=template&id=49d4a033&"
import script from "./ProductSelector.vue?vue&type=script&lang=js&"
export * from "./ProductSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports